import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { SameSystemRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { Box, Grid } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import {
    SecondaryButtonStyle,
    PrimaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';
interface TamigoConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const SameSystemConnect = (props: TamigoConnectProps) => {
    const { t } = useTranslation();
    const [sameSystemData, setSameSystemData] = useState<SameSystemRequest>(
        {} as any
    );
    const { setAlert } = useNotificationsSnackbar();

    const { setupSameSystem } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        setupSameSystem.mutate({
            ...sameSystemData
        });
    };

    useEffect(() => {
        if (setupSameSystem.isSuccess) {
            props.onSaveSuccess();
        }
    }, [setupSameSystem.isSuccess]);

    useEffect(() => {
        dispatch(setLoader(setupSameSystem.isPending));
    }, [setupSameSystem.isPending]);

    useEffect(() => {
        if (setupSameSystem.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [setupSameSystem.isError]);

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={sameSystemData?.username ?? ''}
                    label={'Username'}
                    onChange={(e) => {
                        setSameSystemData({
                            ...sameSystemData,
                            username: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    type="password"
                    value={sameSystemData?.password ?? ''}
                    label={'Password'}
                    onChange={(e) => {
                        setSameSystemData({
                            ...sameSystemData,
                            password: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={sameSystemData?.clientId ?? ''}
                    label={'clientId'}
                    onChange={(e) => {
                        setSameSystemData({
                            ...sameSystemData,
                            clientId: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props?.onClose}
                    sx={{ width: '170px' }}
                >
                    {t('cancel')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle onClick={onClick} sx={{ width: '170px' }}>
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
